import PhotoSwipe from './photoswipe.vue'
import PhotoSwipeGallery from './photoswipe-gallery.vue'

export { PhotoSwipe, PhotoSwipeGallery }
